<template>
  <div class="card" v-if="result.links">
    <div class="card-header">Links</div>
    <div class="card-body">
      <table class="table">
        <tbody>
          <!-- Hide the link contains 'netox' as it is not available anymore -->
          <tr v-for="link in result.links" :key="link.rel" v-if="!link.href.includes('netox')">
            <th scope="row" width="120px">{{ link.rel === 'self'?'json':link.rel }}</th>
            <td>
              <a
                :rel="link.rel"
                :href="link.href"
                class="query"
                id="link"
                target="_blank"
              >{{link.href}}</a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
	props: ["result"]
};
</script>

<style scoped lang="scss">
tbody tr:first-child {
	th,
	td {
		border-top: none;
	}
}
</style>
